import {Pipe, PipeTransform} from '@angular/core';

/**
 * Generated class for the EllipsisPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'ellipsis',
})
export class EllipsisPipe implements PipeTransform {
  transform(value: string, ...args) {
    let words = value.split(' ');
    let wordCount = 0;
    let result = words.reduce((acc, currVal) => {
      if((wordCount + currVal.length) > args[0]) {
        return acc + '';
      }
      wordCount += currVal.length;
      return acc + (wordCount ? ' ' : '') + currVal;
    });
    return result + (value.length > 30 ? '...' : '');
  }
}



// WEBPACK FOOTER //
// ./src/shared/pipes/ellipsis/ellipsis.ts